import { render, staticRenderFns } from "./Prodes2023.vue?vue&type=template&id=85cbb34a&lang=pug"
import script from "./Prodes2023.vue?vue&type=script&lang=js"
export * from "./Prodes2023.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports